import { StateCreator } from 'zustand';
import { NavigationData, NavigationDataSlice } from './NavigationDataTypes';

type ImmerStateCreator<T> = StateCreator<
  T,
  [["zustand/immer", never], never],
  [],
  T
>;

export const NAVIGATION_SLIDE_ACTIONS = {
    ADD_QR: 'ADD_QR',
    ADD_IA: 'ADD_IA',
    REMOVE_NAVIGATION : 'REMOVE_NAVIGATION',
    SET_FORM_EXIT_ALERT : 'SET_FORM_EXIT_ALERT'
} as const

const initialState: NavigationData = {
    QR: undefined,
    IA: undefined,
    showFormExitAlert: false
}

export const createNavigationSlice: ImmerStateCreator<NavigationDataSlice> = (set) => ({ 
    navigationData: initialState,
    ADD_QR: (QR: string) => {  
        set((state) => {
            state.navigationData.QR = QR
        }, false, NAVIGATION_SLIDE_ACTIONS.ADD_QR)
    },
    ADD_IA: (IA: File) => {  
        set((state) => {
            state.navigationData.IA = IA
        }, false, NAVIGATION_SLIDE_ACTIONS.ADD_IA)
    },
    SET_FORM_EXIT_ALERT: (show: boolean) => {  
        set((state) => {
            state.navigationData.showFormExitAlert = show
        }, false, NAVIGATION_SLIDE_ACTIONS.SET_FORM_EXIT_ALERT)
    },
    REMOVE_NAVIGATION: () => {
        set((state) => {
            state.navigationData = initialState
        }, false, NAVIGATION_SLIDE_ACTIONS.REMOVE_NAVIGATION)
    },
});